var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uikit_icon"},[_c('img',{attrs:{"src":`/images/iconset/${_vm.name}.svg`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }